import { getPublicApiHost } from '../utils/public-links/utils';

export const getPublicApiRequestLink = (origin: string, locale: string, pathname: string) => {
  const cleanPath = pathname.replace('/embed', '').split('?')[0];
  return `${getPublicApiHost(origin)}/${locale}/${encodeURIComponent(cleanPath)}`.replace(/^https?:\/\//, '');
};

export const getPublicApiRequestHomeLink = (origin: string, locale: string) => {
  return `${getPublicApiHost(origin)}/${locale}/${encodeURIComponent('/')}`.replace(/^https?:\/\//, '');
};

export class PublicApiRepo {
  public static publicApiUrl = '';
  public static publicApiNavBarUrl = '';

  getReviews = async (): Promise<Reviews> => {
    return new Promise((resolve) => resolve(TRUSTPILOT_DATA));
  };
}
export type Reviews = { reviewsCount: number; reviewsAverage: string };
export const TRUSTPILOT_DATA = { reviewsCount: 516, reviewsAverage: '0.9' };

export const publicApiRepo = new PublicApiRepo();

export const cacheKey = {
  page: (url: string) => `page-${url}`,
  agencies: (url: string, section: 'organic' | 'paid') => `agencies-${url}-${section}`,
  links: (url: string) => `links-${url}`,
  works: (url: string) => `works-${url}`,
  reviews: 'reviews',
};

export const getSortParam = (sort?: string, section = 'organic') => {
  let sortDetails = '';

  if (sort === 'reviews_score' || sort === 'team_size') {
    sortDetails = `&sort=-agencies.${sort}`;
  } else {
    sortDetails = `&sort=-${sort}`;
  }

  return sort !== 'position' && section !== 'paid' ? sortDetails : '';
};
